import _classCallCheck from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _slicedToArray from "/builds/Kf9Z1g-i/0/lf/shoprises-website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var Sequential_1;
import { identity } from '@antv/util';
import { d3Ticks } from '../tick-methods/d3-ticks';
import { compose, createInterpolateNumber, createNormalize, interpolatize } from '../utils';
import { Linear } from './linear';

function rangeOf(interpolator) {
  return [interpolator(0), interpolator(1)];
}

var normalizeDomain = function normalizeDomain(domain) {
  var _domain = _slicedToArray(domain, 2),
      d0 = _domain[0],
      d1 = _domain[1]; // [d0, d1] => [0, 1]


  var normalize = compose(createInterpolateNumber(0, 1), createNormalize(d0, d1));
  return normalize;
};
/**
 * Sequential 比例尺
 *
 * 构造可创建一个在输入和输出之间通过插值函数进行转换的比例尺
 */
// @Sequentialish


var Sequential = Sequential_1 = /*#__PURE__*/function (_Linear) {
  _inherits(Sequential, _Linear);

  var _super = _createSuper(Sequential);

  function Sequential(options) {
    _classCallCheck(this, Sequential);

    return _super.call(this, options);
  }

  _createClass(Sequential, [{
    key: "getDefaultOptions",
    value: function getDefaultOptions() {
      return {
        domain: [0, 1],
        unknown: undefined,
        nice: false,
        clamp: false,
        round: false,
        interpolator: identity,
        tickMethod: d3Ticks,
        tickCount: 5
      };
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Sequential_1(this.options);
    }
  }]);

  return Sequential;
}(Linear);

Sequential = Sequential_1 = __decorate([interpolatize(rangeOf, normalizeDomain)], Sequential);
export { Sequential };